import smartSolveApi from './instances/smartsolve';

export const getSimilarRecords = async (params = {}) => {
  try {
    const response = await smartSolveApi.post('/records-similarity', params);

    return response.data;
  } catch (e) {
    throw new Error(`getSimilarRecords() failed: ${e}`);
  }
};
